module.exports = __webpack_public_path__ + "img/imgheader.1df47233.webp";